/**
 * 一帧怎么落位：和 PetFigure 的姿态图同一套口径——容器高度＝定比例状态（有站姿用站姿）稳定姿势的主体高度，
 * 每一帧按同一像素比例画，实测落地点对准容器底边中点。这样连续帧之间不会因为各自裁边不同而忽大忽小、跳位。
 */
import type { MotionFrame, MotionSet, PreparedMotion } from "./manifest";

const round = (value: number) => Math.round(value * 100) / 100;

export function referenceHeightOf(motion: PreparedMotion): number {
  const box = motion.stable.get(motion.referenceState)!.content_box;
  return box.bottom - box.top;
}

export function framePlacement(frame: MotionFrame, canvas: MotionSet["canvas"], referenceHeight: number): { heightPct: number; aspectRatio: string; transform: string } {
  return {
    heightPct: round((canvas.height / referenceHeight) * 100),
    aspectRatio: `${canvas.width} / ${canvas.height}`,
    transform: `translate(${round(-frame.anchor.x * 100)}%, ${round((1 - frame.anchor.y) * 100)}%)`,
  };
}
